'use strict';exports.__esModule = true;exports.reset = exports.sendEditCompanyByOwnerForm = exports.createCompanyByOwner = exports.loadCompany = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);

var _company = require('./company');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise,batch = _reduxLoop.Effects.batch,call = _reduxLoop.Effects.call;

var createCompanyByOwner = (0, _reduxAct.createAction)('/CREATE_COMPANY_BY_OWNER');
var createCompanyByOwnerSuccess = (0, _reduxAct.createAction)('/CREATE_COMPANY_BY_OWNER_SUCCESS');
var createCompanyByOwnerFail = (0, _reduxAct.createAction)('/CREATE_COMPANY_BY_OWNER_FAIL');

var sendEditCompanyByOwnerForm = (0, _reduxAct.createAction)('/SEND_EDIT_COMPANY_BY_OWNER');
var sendEditCompanyByOwnerSuccess = (0, _reduxAct.createAction)('/SEND_EDIT_COMPANY_BY_OWNER_SUCCESS');
var sendEditCompanyByOwnerSuccessBatch = (0, _reduxAct.createAction)('/SEND_EDIT_COMPANY_BY_OWNER_SUCCESS_BATCH');
var sendEditCompanyByOwnerFail = (0, _reduxAct.createAction)('/SEND_EDIT_COMPANY_BY_OWNER_FAIL');

var reset = (0, _reduxAct.createAction)('/SEND_EDIT_COMPANY_OWNER_BY_RESET');

var loadCompany = (0, _reduxAct.createAction)('/LOAD_COMPANY');
var loadCompanySuccess = (0, _reduxAct.createAction)('/LOAD_COMPANY_SUCCESS');
var loadCompanyFail = (0, _reduxAct.createAction)('/LOAD_COMPANY_FAIL');

var initialState = {
  data: null,
  loading: false,
  loaded: false,
  formSubmitting: false,
  formSubmitted: false };


var fetchLoad = function fetchLoad(_ref) {var id = _ref.id,access_token = _ref.access_token;return _axios2.default.get('agencies/' + id + '/my', { headers: { access_token: access_token } }).
  then(loadCompanySuccess, loadCompanyFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoad, action));};

var handleLoadSuccess = function handleLoadSuccess(state, _ref2) {var data = _ref2.data;return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while loading company');
  error.status = response.response.status;

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var submitEditOwnerForm = function submitEditOwnerForm(_ref3) {var id = _ref3.id,data = _ref3.data,access_token = _ref3.access_token;return _axios2.default.
  put('agencies/' + id, data, { headers: { access_token: access_token } }).
  then(sendEditCompanyByOwnerSuccessBatch, sendEditCompanyByOwnerFail);};

var submitCreateCompanyByOwner = function submitCreateCompanyByOwner(_ref4) {var data = _ref4.data,access_token = _ref4.access_token;return _axios2.default.
  post('agencies', data, { headers: { access_token: access_token } }).
  then(createCompanyByOwnerSuccess, createCompanyByOwnerFail);};

var handleEditCompanyByOwnerForm = function handleEditCompanyByOwnerForm(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    submitting: true }),
  promise(submitEditOwnerForm, action));};

var handleCreateCompanyByOwner = function handleCreateCompanyByOwner(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    submitting: true }),
  promise(submitCreateCompanyByOwner, action));};

var handleEditCompanyByOwnerSuccess = function handleEditCompanyByOwnerSuccess(state, _ref5) {var data = _ref5.data;return Object.assign({},
  state, {
    submitting: false,
    submitted: true,
    data: data,
    formError: null });};


var handleEditCompanyByOwnerBatchSuccess = function handleEditCompanyByOwnerBatchSuccess(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state),
  batch([
  call(sendEditCompanyByOwnerSuccess, action),
  call(_company.loadCompanySuccess, action)]));};



var handleEditCompanyByOwnerFail = function handleEditCompanyByOwnerFail(state, _ref6) {var response = _ref6.response;return Object.assign({},
  state, {
    submitting: false,
    submitted: false,
    formError: response.data });};


var handleCreateCompanyByOwnerSuccess = function handleCreateCompanyByOwnerSuccess(state, _ref7) {var data = _ref7.data;return Object.assign({},
  state, {
    submitting: false,
    submitted: true,
    data: data,
    formError: null });};


var handleCreateCompanyByOwnerFail = function handleCreateCompanyByOwnerFail(state, _ref8) {var response = _ref8.response;return Object.assign({},
  state, {
    submitting: false,
    submitted: false,
    formError: response.data });};


var handleEditCompanyByOwnerReset = function handleEditCompanyByOwnerReset() {return Object.assign({}, initialState);};

var editCompanyByOwner = (0, _reduxAct.createReducer)(function (on) {
  on(createCompanyByOwner, handleCreateCompanyByOwner);
  on(createCompanyByOwnerSuccess, handleCreateCompanyByOwnerSuccess);
  on(createCompanyByOwnerFail, handleCreateCompanyByOwnerFail);

  on(sendEditCompanyByOwnerForm, handleEditCompanyByOwnerForm);
  on(sendEditCompanyByOwnerSuccessBatch, handleEditCompanyByOwnerBatchSuccess);
  on(sendEditCompanyByOwnerSuccess, handleEditCompanyByOwnerSuccess);
  on(sendEditCompanyByOwnerFail, handleEditCompanyByOwnerFail);

  on(reset, handleEditCompanyByOwnerReset);

  on(loadCompany, handleLoad);
  on(loadCompanySuccess, handleLoadSuccess);
  on(loadCompanyFail, handleLoadFail);
}, initialState);exports.


loadCompany = loadCompany;exports.
createCompanyByOwner = createCompanyByOwner;exports.
sendEditCompanyByOwnerForm = sendEditCompanyByOwnerForm;exports.
reset = reset;exports.default =


editCompanyByOwner;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/editCompanyByOwner.js
// module id = 1267
// module chunks = 0